module.exports = __webpack_public_path__ + "images/button_small_vertical_blank_3efa61c9049705cefcc0512dd0620b3a.svg";